<modal [ngClass]="getModalClass()">
  @if (title) {
    <ng-container ngProjectAs="modal-header"
      ><modal-header [title]="title"></modal-header
    ></ng-container>
  }
  <modal-content [ngClass]="contentAlign" [ngStyle]="modalContentStyle">
    @if (hasIcon) {
      <i class="icon-confirm {{ iconVariant }}"></i>
    }
    @if (contentTitle) {
      <modal-content-title [contentTitle]="contentTitle"></modal-content-title>
    }
    {{ message | translate: messageParams }}
  </modal-content>
  <modal-footer>
    @for (button of modalButtons; track button) {
      <button
        [ngClass]="button.style"
        [attr.e2e-attr]="button.e2eAttr"
        (click)="buttonClick(button)"
      >
        {{ button.text | translate }}
      </button>
    }
  </modal-footer>
</modal>
